import React, { useMemo, useState } from 'react';
import FeedbackLabel from '../../components/label/FeedbackLabel';

export default function useFeedbackLabel({
  initialState = null,
  className = 'mb-md',
  t = undefined,
  transPath = undefined,
} = {}) {
  const emptyState = {
    message: '',
    type: '',
    errors: null,
  };

  const [feedback, setFeedback] = useState(initialState);

  const resetFeedback = () => setFeedback(emptyState);

  const setErrorFeedback = (response) =>
    setFeedback({
      type: 'error',
      message: response?.message,
      errors: response?.errors,
    });

  const renderFeedbackLabel = useMemo(
    () =>
      feedback?.message && (
        <FeedbackLabel
          message={feedback?.message}
          type={feedback?.type}
          errors={feedback?.errors}
          className={className}
          t={t}
          transPath={transPath}
        />
      ),
    [feedback, t, transPath, className],
  );

  // For a form that shows some fields' errors under the fields themselves: the label keeps
  // only the rest — other fields' errors, or a message that belongs to no field — and is
  // not shown at all when every error is already under its field.
  const renderFeedbackLabelWithout = (fields = []) => {
    if (!feedback?.message) {
      return null;
    }

    const errors = feedback.errors ?? {};
    const rest = Object.fromEntries(Object.entries(errors).filter(([key]) => !fields.includes(key)));

    if (Object.keys(errors).length > 0 && Object.keys(rest).length === 0) {
      return null;
    }

    return (
      <FeedbackLabel
        message={feedback.message}
        type={feedback.type}
        errors={rest}
        className={className}
        t={t}
        transPath={transPath}
      />
    );
  };

  return {
    feedback,
    setFeedback,
    resetFeedback,
    setErrorFeedback,
    renderFeedbackLabel,
    renderFeedbackLabelWithout,
  };
}
